import { create } from 'zustand';

// Define TypeScript interfaces for common application state
export interface CommonState {
  embedded: boolean;
  oscAccountType: string | null;
  segmentLayout: string | null;
  segmentMode: string | null;
  jwtToken: string | null;
  partnerName: string | null;
}

export const initialCommonState: CommonState = {
  embedded: false,
  oscAccountType: null,
  segmentLayout: null,
  segmentMode: null,
  jwtToken: null,
  partnerName: null,
};

// Define the actions available in the common store
interface CommonActions {
  setCommonState: (state: Partial<CommonState>) => void;
  setEmbedded: (embedded: boolean) => void;
  setOscAccountType: (type: string | null) => void;
  setSegmentLayout: (layout: string | null) => void;
  setSegmentMode: (mode: string | null) => void;
  setJwtToken: (token: string | null) => void;
  setPartnerName: (name: string | null) => void;
}

// Combine state and actions for the store type
type CommonStore = CommonState & CommonActions;

// Create the common store
export const useCommonStore = create<CommonStore>((set) => ({
  ...initialCommonState,

  setCommonState: (state: Partial<CommonState>) => set(state),

  setEmbedded: (embedded: boolean) => set({ embedded }),
  setOscAccountType: (oscAccountType: string | null) => set({ oscAccountType }),
  setSegmentLayout: (segmentLayout: string | null) => set({ segmentLayout }),
  setSegmentMode: (segmentMode: string | null) => set({ segmentMode }),
  setJwtToken: (jwtToken: string | null) => set({ jwtToken }),
  setPartnerName: (partnerName: string | null) => {
    set({ partnerName });
  },
}));

// Export selectors separately for better type inference and usage
export const selectEmbedded = (state: CommonStore) => state.embedded;

export const selectOscAccountType = (state: CommonStore) => state.oscAccountType;

export const selectSegmentLayout = (state: CommonStore) => state.segmentLayout;

export const selectSegmentMode = (state: CommonStore) => state.segmentMode;

export const selectJwtToken = (state: CommonStore) => state.jwtToken;

export const selectPartnerName = (state: CommonStore): string | null => {
  return state.partnerName ?? '';
};
